import {apiService} from '../../../core/api';
import {API_ENDPOINTS} from '../../../core/constants/endpoints';
import {
  UserDetailResponse,
  UserDetailApiResponse,
} from '../model/types';

export class UsersService {
  async getUserById(id: string): Promise<UserDetailResponse> {
    const response = await apiService.get<UserDetailApiResponse>(API_ENDPOINTS.USER.GET_USER(id));
    return response.data;
  }

  async toggleUserFollow(userId: string, isFollowing: boolean): Promise<void> {
    // console.log('Toggling follow status for userId:', userId, 'isFollowing:', isFollowing);
    return await apiService.post(API_ENDPOINTS.USER.FOLLOW, {
      action_mode: isFollowing ? 'remove' : 'add',
      follow_uid: userId,
    });
  }
}

export const usersService = new UsersService();